import axios from "@/api/axiosInstance";
import { FetchDashboardChartConfigResponse } from "./types";

export const fetchDashboardChartConfig =
  async (): Promise<FetchDashboardChartConfigResponse> => {
    const response = await axios.get<FetchDashboardChartConfigResponse>(
      "/api/private/stochastic/sales-and-customer-dashboard/chart-config",
    );
    return response.data;
  };
